<template lang="pug">
main#v-welcome: .container
  h1 CONNECT
  h2
    | to
    br
    | the
    |
    em Future
  h3
    span 2
    span 0
    span 3
    span 0
  img(v-scroll-to='{el: "#v-features", offset: -$store.state.scroll.offset}', src='@/assets/arrow-down-icon.png', width='20')
</template>

<script>
export default {
  name: 'Welcome',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

@keyframes arrow
  0%
    transform: translateY(0)
  50%
    transform: translateY(-10px)
  100%
    transform: translateY(0)

#v-welcome
  +background((url(~@/assets/main-background.jpg), url(~@/assets/main-ribbon-background.png)), (cover, 60px), no-repeat, (right 50px bottom 50px, right bottom -9px))
  background-color: #DFFF00
  padding-top: 105px
  padding-bottom: 100px
  .container
    position: relative
h1
  +font(170px, white, null, 4px)
  font-family: Righteous
h2
  +font(68px, white, 80px, null, 800)
  font-family: 'Montserrat Alternates'
  margin-bottom: 110px
  em
    color: #DFFF00
  &::after
    border-bottom: 8px solid #DFFF00
    content: ''
    display: block
    padding-bottom: 20px
    width: 100px
h3
  +font(60px, #DFFF00)
  font-family: Righteous
  span:nth-child(1)
    +position(absolute, 26px, 34px)
  span:nth-child(2)
    +position(absolute, 78px, 78px)
  span:nth-child(3)
    +position(absolute, 130px, 34px)
  span:nth-child(4)
    +position(absolute, 182px, 78px)
img
  animation: arrow 1s infinite
  box-sizing: content-box
  cursor: pointer
  display: block
  margin-left: auto
  margin-right: auto
  padding: 10px

@media (max-width: 1023px)
  #v-welcome
    +background((url(~@/assets/m-main-background.png), url(~@/assets/main-ribbon-background.png)), (cover, 60px), no-repeat, (right 25px bottom 30px, right bottom -4px))
    padding-bottom: 0
    padding-top: 25px
    height: 600px
  h1
    +font(90px, null, null, 10px)
    +position(absolute, 0, null, null, 30px)
    transform-origin: .5em .5em
    transform: rotate(90deg)
  h2
    +font(34px, null, 40px)
    +position(absolute, 214px, null, null, 130px)
    &::after
      border-width: 6px
      padding-bottom: 12px
      width: 60px
  h3
    font-size: 40px
    span:nth-child(1)
      +position(null, 0, 50px)
    span:nth-child(2)
      +position(null, 38px, 78px)
    span:nth-child(3)
      +position(null, 76px, 50px)
    span:nth-child(4)
      +position(null, 114px, 78px)
  img
    +position(relative, 440px)
</style>
